<div *ngIf=" !isHandset else mobileTemplate">  
  <div class="filterBox" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275">
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Military Units</h4>
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <div class="filterListSection">
      <div class="grid headers"> <!-- Persistent headers -->
        <div class="column-header">
          Army
        </div>
        <div class="column-header">
          Corps
        </div>
        <div class="column-header">
          Regiment #
        </div>
        <div class="column-header">
          State
        </div>
        <div class="column-header">
          Branch
        </div>
        <div class="column-header">
          Companies <sup matTooltip="You can choose multiple companies">†</sup>
        </div>
        <div></div>
      </div>
      <ol class="filterList slide-fade">
        <li class="unitFilter show grid" *ngFor="let u of activeUnitFilters; let i = index">
            <div>
              {{ unitArmies[u.army] || '*' }}
            </div>
            <div>
              {{ (u.corps) ? ordinalSuffix(u.corps) : '*' }}
            </div>
            <div>
              {{ (u.regiment?.regimentNo) ? ordinalSuffix(u.regiment.regimentNo) : '*' }}
            </div>
            <div style="overflow: hidden; white-space: nowrap;">
              {{ u.state?.state_Name || '*' }}
            </div>
            <div>
              {{ u.branch?.branchName || '*' }}
            </div>
            <div>
              {{ u.coLetters?.join(', ') }}
            </div>
          <button class="btn btn-link btn-lg deleteButton" matTooltip="Remove this unit from filter selection" (click)="removeFromFilterList(i)">
            <i class="fal fa-times" style="vertical-align: top;"></i>
          </button>
        </li>
      </ol>
      <app-unit-picker [showHeaders]="false" [regiments]="regiments" [states]="states" [branches]="branches" [coLetters]="coLetters" [resetAfterAdd]="true" (unitSelected)="addToFilterList($event)"></app-unit-picker>
    </div>
    <hr>
    <app-slant-button btnColor="blue" [linkMode]="true" id="closeButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)">Close</app-slant-button>
    <app-slant-button btnColor="gray" [linkMode]="true" id="cancelButton" tooltip="Clear all unit filters and close this box" [disabled]="!activeUnitFilters.length" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Unit Filters</app-slant-button>
    <span style="float: right; padding: .5em .5em 0 0;">
      <label class="text-muted" *ngIf="activeUnitFilters.length">
        {{ activeUnitFilters.length }} unit filter(s) applied
      </label>
    </span>
  </div>
</div>

<ng-template #mobileTemplate>
  <div class="filterBox mobile" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275">
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Military Units</h4>
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <div class="filterListSection mobile">
      <div class="grid headers"> <!-- Persistent headers -->
        <div class="column-header">
          Army
        </div>
        <div class="column-header">
          Corps
        </div>
        <div class="column-header short-text">
          Regiment #
        </div>
        <div class="column-header">
          State
        </div>
        <div class="column-header">
          Branch
        </div>
        <div class="column-header short-text">
          Companies <sup matTooltip="You can choose multiple companies">†</sup>
        </div>
        <div></div>
      </div>
      <ol class="filterList slide-fade">
        <li class="unitFilter show grid" *ngFor="let u of activeUnitFilters; let i = index">
            <div>
              {{ unitArmies[u.army] || '*' }}
            </div>
            <div>
              {{ (u.corps) ? ordinalSuffix(u.corps) : '*' }}
            </div>
            <div>
              {{ (u.regiment?.regimentNo) ? ordinalSuffix(u.regiment.regimentNo) : '*' }}
            </div>
            <div>
              {{ u.state?.abbreviation || '*' }}
            </div>
            <div class="short-text">
              {{ u.branch?.branchName || '*' }}
            </div>
            <div>
              {{ u.coLetters?.join(', ') }}
            </div>
          <button class="btn btn-link btn-lg deleteButton" matTooltip="Remove this unit from filter selection" (click)="removeFromFilterList(i)">
            <i class="fal fa-times" style="vertical-align: top;"></i>
          </button>
        </li>
      </ol>
      <hr>
      <app-unit-picker [showHeaders]="false" [regiments]="regiments" [states]="states" [branches]="branches" [coLetters]="coLetters" [resetAfterAdd]="true" (unitSelected)="addToFilterList($event)"></app-unit-picker>
    </div>
    <hr>
    <app-slant-button btnColor="blue" [linkMode]="true" id="closeButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)">Close</app-slant-button>
    <app-slant-button btnColor="gray" [linkMode]="true" id="cancelButton" tooltip="Clear all unit filters and close this box" [disabled]="!activeUnitFilters.length" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Unit Filters</app-slant-button>
    <span style="float: right; padding: .5em .5em 0 0;">
      <label class="text-muted" *ngIf="activeUnitFilters.length">
        {{ activeUnitFilters.length }} unit filter(s) applied
      </label>
    </span>
  </div>

</ng-template>
